// OSIS - Emitere Facturi - Sistem complet facturare pentru pardoseli industriale
import React, { useState } from 'react';
import { 
  FileText, 
  Plus, 
  Download, 
  Search, 
  Filter,
  Eye,
  Edit,
  Send,
  Printer,
  CheckCircle,
  AlertCircle,
  Clock,
  Calculator,
  User,
  Building,
  Calendar,
  DollarSign
} from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const EmitereFacturi = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('toate');
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newInvoice, setNewInvoice] = useState({
    client: '',
    products: [],
    discount: 0,
    notes: ''
  });

  // Facturi OSIS
  const facturaData = [
    {
      id: 'FACT-2024-001',
      numar: 'TBC001',
      client: 'Popescu Maria',
      tipClient: 'Persoană fizică',
      adresaClient: 'Str. Florilor 25, Suceava',
      telefonClient: '+40 722 123 456',
      emailClient: 'maria.popescu@email.com',
      data: '2024-09-01',
      scadenta: '2024-10-01',
      produse: [
        { 
          descriere: 'proiect epoxidic Sika 3 camere 120x140cm', 
          cantitate: 6, 
          pretUnitar: 450, 
          total: 2700,
          tva: 19
        },
        { 
          descriere: 'Aplicare Pardoseli + etanșare', 
          cantitate: 6, 
          pretUnitar: 80, 
          total: 480,
          tva: 19
        }
      ],
      subtotal: 3180,
      tva: 604.20,
      total: 3784.20,
      status: 'Plătită',
      metodaPlata: 'Transfer bancar',
      dataPlata: '2024-09-15',
      observatii: 'Plata efectuată în termenul legal'
    },
    {
      id: 'FACT-2024-002',
      numar: 'TBC002',
      client: 'SC Constructor Alpha SRL',
      tipClient: 'Persoană juridică',
      adresaClient: 'Bd. Eroilor 15, Suceava',
      telefonClient: '+40 721 987 654',
      emailClient: 'facturi@constructoralpha.ro',
      data: '2024-09-03',
      scadenta: '2024-10-03',
      produse: [
        { 
          descriere: 'proiecte epoxidic Sika 5 camere 150x160cm premium', 
          cantitate: 24, 
          pretUnitar: 620, 
          total: 14880,
          tva: 19
        },
        { 
          descriere: 'lucrări balcon epoxidic cu geam triplu', 
          cantitate: 6, 
          pretUnitar: 850, 
          total: 5100,
          tva: 19
        },
        { 
          descriere: 'Montaj complet cu transport', 
          cantitate: 1, 
          pretUnitar: 2500, 
          total: 2500,
          tva: 19
        }
      ],
      subtotal: 22480,
      tva: 4271.20,
      total: 26751.20,
      status: 'Emisă',
      metodaPlata: 'Transfer bancar',
      dataPlata: null,
      observatii: 'Proiect reabilitare bloc, prioritate ridicată'
    },
    {
      id: 'FACT-2024-003',
      numar: 'TBC003',
      client: 'Georgescu Ion',
      tipClient: 'Persoană fizică',
      adresaClient: 'Str. Mihai Viteazu 8, Râșnov',
      telefonClient: '+40 723 456 789',
      emailClient: 'ion.georgescu@email.com',
      data: '2024-09-05',
      scadenta: '2024-10-05',
      produse: [
        { 
          descriere: 'proiecte epoxidic stejar 3 camere 100x120cm', 
          cantitate: 8, 
          pretUnitar: 485, 
          total: 3880,
          tva: 19
        },
        { 
          descriere: 'lucrare garaj epoxidic cu geam', 
          cantitate: 1, 
          pretUnitar: 1200, 
          total: 1200,
          tva: 19
        },
        { 
          descriere: 'Montaj și finisări', 
          cantitate: 1, 
          pretUnitar: 650, 
          total: 650,
          tva: 19
        }
      ],
      subtotal: 5730,
      tva: 1088.70,
      total: 6818.70,
      status: 'În așteptare',
      metodaPlata: 'Numerar',
      dataPlata: null,
      observatii: 'Client fidel - discount 5% aplicat'
    },
    {
      id: 'FACT-2024-004',
      numar: 'TBC004',
      client: 'Vila Primăverii SRL',
      tipClient: 'Persoană juridică',
      adresaClient: 'Str. Postavaru 12, Predeal',
      telefonClient: '+40 724 567 890',
      emailClient: 'contabilitate@vilaprimaverii.ro',
      data: '2024-09-07',
      scadenta: '2024-10-07',
      produse: [
        { 
          descriere: 'Ferește panoramice aluminiu 200x240cm', 
          cantitate: 2, 
          pretUnitar: 1350, 
          total: 2700,
          tva: 19
        },
        { 
          descriere: 'proiecte epoxidic premium 5 camere Low-E', 
          cantitate: 4, 
          pretUnitar: 580, 
          total: 2320,
          tva: 19
        },
        { 
          descriere: 'Montaj specializat cu echipamente', 
          cantitate: 1, 
          pretUnitar: 1800, 
          total: 1800,
          tva: 19
        }
      ],
      subtotal: 6820,
      tva: 1295.80,
      total: 8115.80,
      status: 'Draft',
      metodaPlata: 'Transfer bancar',
      dataPlata: null,
      observatii: 'Vila de lux - produse premium cu garanție extinsă'
    },
    {
      id: 'FACT-2024-005',
      numar: 'TBC005',
      client: 'Marinescu Ana',
      tipClient: 'Persoană fizică',
      adresaClient: 'Str. Dealul Mare 33, Suceava',
      telefonClient: '+40 722 678 901',
      emailClient: 'ana.marinescu@email.com',
      data: '2024-09-10',
      scadenta: '2024-10-10',
      produse: [
        { 
          descriere: 'proiecte mansardă epoxidic cu deschidere specială', 
          cantitate: 4, 
          pretUnitar: 680, 
          total: 2720,
          tva: 19
        },
        { 
          descriere: 'Montaj mansardă cu acces dificil', 
          cantitate: 1, 
          pretUnitar: 450, 
          total: 450,
          tva: 19
        }
      ],
      subtotal: 3170,
      tva: 602.30,
      total: 3772.30,
      status: 'Plătită',
      metodaPlata: 'Card',
      dataPlata: '2024-09-12',
      observatii: 'Montaj finalizat cu succes, client mulțumit'
    }
  ];

  // KPI-uri facturare
  const facturareKPIs = {
    totalFacturi: facturaData.length,
    valoareTotala: facturaData.reduce((sum, f) => sum + f.total, 0),
    factoriPlatite: facturaData.filter(f => f.status === 'Plătită').length,
    factoriRestante: facturaData.filter(f => f.status === 'În așteptare').length
  };

  // Filtrare facturi
  const filteredInvoices = facturaData.filter(factura => {
    const matchesSearch = factura.numar.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         factura.client.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === 'toate' || factura.status.toLowerCase() === filterStatus.toLowerCase();
    return matchesSearch && matchesStatus;
  });

  const getStatusColor = (status) => {
    switch(status) {
      case 'Plătită': return 'success';
      case 'Emisă': return 'info';
      case 'În așteptare': return 'warning';
      case 'Draft': return 'gray';
      case 'Anulată': return 'error';
      default: return 'gray';
    }
  };

  const getStatusIcon = (status) => {
    switch(status) {
      case 'Plătită': return <CheckCircle className="w-4 h-4" />;
      case 'Emisă': return <Send className="w-4 h-4" />;
      case 'În așteptare': return <Clock className="w-4 h-4" />;
      case 'Draft': return <Edit className="w-4 h-4" />;
      case 'Anulată': return <AlertCircle className="w-4 h-4" />;
      default: return <FileText className="w-4 h-4" />;
    }
  };

  const handleViewInvoice = (factura) => {
    setSelectedInvoice(factura);
    setShowInvoiceModal(true);
  };

  const tableColumns = [
    {
      header: 'Nr. Factură',
      accessor: 'numar',
      cell: (row) => (
        <div className="flex items-center space-x-3">
          {getStatusIcon(row.status)}
          <div>
            <p className="font-semibold text-gray-900 dark:text-white">{row.numar}</p>
            <p className="text-sm text-gray-500">{row.id}</p>
          </div>
        </div>
      ),
    },
    {
      header: 'Client',
      accessor: 'client',
      cell: (row) => (
        <div className="flex items-center space-x-2">
          {row.tipClient === 'Persoană juridică' ? 
            <Building className="w-4 h-4 text-gray-400" /> : 
            <User className="w-4 h-4 text-gray-400" />
          }
          <div>
            <p className="font-medium text-gray-900 dark:text-white">{row.client}</p>
            <p className="text-sm text-gray-500">{row.tipClient}</p>
          </div>
        </div>
      ),
    },
    {
      header: 'Data',
      accessor: 'data',
      cell: (row) => (
        <div className="flex items-center space-x-2">
          <Calendar className="w-4 h-4 text-gray-400" />
          <div>
            <p className="text-sm font-medium">{new Date(row.data).toLocaleDateString('ro-RO')}</p>
            <p className="text-xs text-gray-500">Scadență: {new Date(row.scadenta).toLocaleDateString('ro-RO')}</p>
          </div>
        </div>
      ),
    },
    {
      header: 'Valoare',
      accessor: 'total',
      cell: (row) => (
        <div className="text-right">
          <p className="font-bold text-gray-900 dark:text-white">
            {row.total.toLocaleString('ro-RO', { minimumFractionDigits: 2 })} RON
          </p>
          <p className="text-xs text-gray-500">
            {row.produse.length} produs{row.produse.length !== 1 ? 'e' : ''}
          </p>
        </div>
      ),
    },
    {
      header: 'Status',
      accessor: 'status',
      cell: (row) => (
        <div className="flex items-center space-x-2">
          <Badge variant={getStatusColor(row.status)}>
            {row.status}
          </Badge>
          {row.status === 'În așteptare' && (
            <span className="text-xs text-red-600">
              {Math.floor((new Date() - new Date(row.scadenta)) / (1000 * 60 * 60 * 24))} zile
            </span>
          )}
        </div>
      ),
    },
    {
      header: 'Acțiuni',
      accessor: 'actions',
      cell: (row) => (
        <div className="flex items-center space-x-2">
          <button
            onClick={() => handleViewInvoice(row)}
            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
            title="Vezi detalii"
          >
            <Eye className="w-4 h-4" />
          </button>
          <button
            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
            title="Descarcă PDF"
          >
            <Download className="w-4 h-4" />
          </button>
          <button
            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
            title="Tipărește"
          >
            <Printer className="w-4 h-4" />
          </button>
          <button
            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
            title="Trimite email"
          >
            <Send className="w-4 h-4" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Emitere Facturi OSIS
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Sistem complet facturare pentru pardoseli industriale cu integrare ANAF
          </p>
        </div>
        
        <div className="flex gap-3">
          <button className="btn-secondary flex items-center gap-2">
            <Download className="w-4 h-4" />
            Export Lunar
          </button>
          <button 
            onClick={() => setShowCreateModal(true)}
            className="btn-primary flex items-center gap-2"
          >
            <Plus className="w-4 h-4" />
            Factură Nouă
          </button>
        </div>
      </div>

      {/* KPI-uri */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Total Facturi</p>
              <p className="text-2xl font-bold text-gray-900 dark:text-white">{facturareKPIs.totalFacturi}</p>
            </div>
            <FileText className="w-8 h-8 text-primary-600" />
          </div>
        </Card>

        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Valoare Totală</p>
              <p className="text-2xl font-bold text-primary-600">
                {facturareKPIs.valoareTotala.toLocaleString('ro-RO')} RON
              </p>
            </div>
            <DollarSign className="w-8 h-8 text-primary-600" />
          </div>
        </Card>

        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Facturi Plătite</p>
              <p className="text-2xl font-bold text-green-600">{facturareKPIs.factoriPlatite}</p>
            </div>
            <CheckCircle className="w-8 h-8 text-green-600" />
          </div>
        </Card>

        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Restanțe</p>
              <p className="text-2xl font-bold text-red-600">{facturareKPIs.factoriRestante}</p>
            </div>
            <AlertCircle className="w-8 h-8 text-red-600" />
          </div>
        </Card>
      </div>

      {/* Filtre și Căutare */}
      <Card>
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Căutare factură sau client..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="form-input pl-10"
              />
            </div>
          </div>
          
          <div className="flex gap-3">
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="form-input"
            >
              <option value="toate">Toate statusurile</option>
              <option value="draft">Draft</option>
              <option value="emisă">Emisă</option>
              <option value="în așteptare">În așteptare</option>
              <option value="plătită">Plătită</option>
              <option value="anulată">Anulată</option>
            </select>
            
            <button className="btn-secondary flex items-center gap-2">
              <Filter className="w-4 h-4" />
              Mai multe filtre
            </button>
          </div>
        </div>
      </Card>

      {/* Tabel Facturi */}
      <Card title="Lista Facturilor" icon={FileText}>
        <div className="overflow-x-auto">
          <Table 
            columns={tableColumns} 
            data={filteredInvoices}
          />
        </div>
      </Card>

      {/* Modal Vizualizare Factură */}
      <Modal
        isOpen={showInvoiceModal}
        onClose={() => setShowInvoiceModal(false)}
        title={`Factură ${selectedInvoice?.numar || ''}`}
        size="lg"
      >
        {selectedInvoice && (
          <div className="space-y-6">
            {/* Header factură */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                  Informații Factură
                </h3>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Numărul facturii:</span>
                    <span className="font-semibold">{selectedInvoice.numar}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Data emisiunii:</span>
                    <span>{new Date(selectedInvoice.data).toLocaleDateString('ro-RO')}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Scadență:</span>
                    <span>{new Date(selectedInvoice.scadenta).toLocaleDateString('ro-RO')}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Status:</span>
                    <Badge variant={getStatusColor(selectedInvoice.status)}>
                      {selectedInvoice.status}
                    </Badge>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                  Date Client
                </h3>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Denumire:</span>
                    <span className="font-semibold">{selectedInvoice.client}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Tip:</span>
                    <span>{selectedInvoice.tipClient}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Telefon:</span>
                    <span>{selectedInvoice.telefonClient}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Email:</span>
                    <span>{selectedInvoice.emailClient}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Produse facturate */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                Produse și Servicii
              </h3>
              <div className="overflow-hidden border border-gray-200 dark:border-gray-700 rounded-lg">
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                  <thead className="bg-gray-50 dark:bg-gray-800">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                        Descriere
                      </th>
                      <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                        Cant.
                      </th>
                      <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                        Preț unitar
                      </th>
                      <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
                    {selectedInvoice.produse.map((produs, index) => (
                      <tr key={index}>
                        <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">
                          {produs.descriere}
                        </td>
                        <td className="px-4 py-3 text-sm text-center text-gray-700 dark:text-gray-300">
                          {produs.cantitate}
                        </td>
                        <td className="px-4 py-3 text-sm text-right text-gray-700 dark:text-gray-300">
                          {produs.pretUnitar.toLocaleString('ro-RO')} RON
                        </td>
                        <td className="px-4 py-3 text-sm text-right font-medium text-gray-900 dark:text-white">
                          {produs.total.toLocaleString('ro-RO')} RON
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Total factură */}
              <div className="mt-4 bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span>Subtotal:</span>
                    <span>{selectedInvoice.subtotal.toLocaleString('ro-RO')} RON</span>
                  </div>
                  <div className="flex justify-between">
                    <span>TVA (19%):</span>
                    <span>{selectedInvoice.tva.toLocaleString('ro-RO')} RON</span>
                  </div>
                  <div className="flex justify-between border-t pt-2 font-bold text-lg">
                    <span>Total de plată:</span>
                    <span className="text-primary-600">
                      {selectedInvoice.total.toLocaleString('ro-RO')} RON
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Informații plată */}
            {selectedInvoice.status === 'Plătită' && (
              <div className="bg-green-50 dark:bg-green-900/20 p-4 rounded-lg">
                <h4 className="font-semibold text-green-800 dark:text-green-200 mb-2">
                  Informații Plată
                </h4>
                <div className="grid grid-cols-2 gap-4 text-sm text-green-700 dark:text-green-300">
                  <div>
                    <span className="block text-green-600">Metodă plată:</span>
                    <span className="font-medium">{selectedInvoice.metodaPlata}</span>
                  </div>
                  <div>
                    <span className="block text-green-600">Data plății:</span>
                    <span className="font-medium">
                      {new Date(selectedInvoice.dataPlata).toLocaleDateString('ro-RO')}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* Observații */}
            {selectedInvoice.observatii && (
              <div>
                <h4 className="font-semibold text-gray-900 dark:text-white mb-2">
                  Observații
                </h4>
                <div className="bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg">
                  <p className="text-blue-800 dark:text-blue-200 text-sm">
                    {selectedInvoice.observatii}
                  </p>
                </div>
              </div>
            )}

            {/* Acțiuni */}
            <div className="flex justify-end gap-3 pt-4 border-t">
              <button className="btn-secondary flex items-center gap-2">
                <Download className="w-4 h-4" />
                Descarcă PDF
              </button>
              <button className="btn-secondary flex items-center gap-2">
                <Printer className="w-4 h-4" />
                Tipărește
              </button>
              <button className="btn-primary flex items-center gap-2">
                <Send className="w-4 h-4" />
                Trimite Email
              </button>
            </div>
          </div>
        )}
      </Modal>

      {/* Modal Creare Factură Nouă */}
      <Modal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        title="Factură Nouă"
        size="lg"
      >
        <div className="space-y-6">
          <div className="text-center py-12">
            <Calculator className="w-16 h-16 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              Creator Factură în Dezvoltare
            </h3>
            <p className="text-gray-600 dark:text-gray-400 mb-6">
              Funcționalitatea de creare facturi va fi disponibilă în curând.<br />
              Momentan, facturile se introduc manual în sistem.
            </p>
            <button 
              onClick={() => setShowCreateModal(false)}
              className="btn-primary"
            >
              Închide
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EmitereFacturi;